import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../../sysadmin/services/StringRequest";
import { CreateSubRequest } from "../../shared/CreateSubRequest";
import { DataService_SubstituteMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-add-substitute-person",
	templateUrl: "./add-substitute-person.component.html",
	styleUrls: ["./add-substitute-person.component.css"],
})
export class AddSubstitutePersonComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SubstituteMaintenanceService: DataService_SubstituteMaintenance
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SchoolNumber = this.dialogConfig.data.SchoolNumber;
		this.SchoolName = this.dialogConfig.data.SchoolName;

		//INSERT LOAD COMBO BOX DATA
		this.loadEmailProviders();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	user: any;
	SchoolID: any;
	SchoolNumber: any = "";
	SchoolName: any = "";

	//INSERT FORM DATA
	FirstName: any = "";
	LastName: any = "";
	UserName: any = "";

	Email: any = "";
	EmailProvider: any;
	lstEmail: any = [];

	DomainSelect: any = "Dropdown";

	LoadingEmail: any = true;
	processing: any = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS
	loadEmailProviders() {
		this.LoadingEmail = true;

		var result = this.SubstituteMaintenanceService.EmailProviderSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingEmail = false;

				this.lstEmail = response;

				if (this.lstEmail.length == 0) {
					this.lstEmail.unshift({
						EmailProviderID: -1,
						EmailProviderEmailInfo: "",
					});
				}

				this.EmailProvider = this.lstEmail[0];
			},
			(error) => {
				this.LoadingEmail = false;
			}
		);
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onAdd() {
		this.processing = true;

		this.errorMessage = "";

		//
		// Error handling
		//
		if (this.FirstName == "") {
			this.errorMessage = "Enter sub's first name";
			this.processing = false;
			return;
		}
		if (this.LastName == "") {
			this.errorMessage = "Enter sub's last name";
			this.processing = false;
			return;
		}
		if (this.UserName == "") {
			this.errorMessage = "Enter username to create an account for a substitute";
			this.processing = false;
			return;
		}
		if (this.Email == "") {
			this.errorMessage = "Enter email to send the new user's username and password";
			this.processing = false;
			return;
		}
		if (this.DomainSelect == "Manual" && String(this.Email).indexOf("@") == -1) {
			this.errorMessage = "Enter a valid email (must include domain name ex. @gmail.com)";
			this.processing = false;
			return;
		}

		this.CheckUsernameInUse();
	}

	CheckUsernameInUse() {
		let parms: StringRequest = {
			str: this.UserName,
		};

		var result = this.SubstituteMaintenanceService.UserNameAlreadyUsed(parms);
		result.subscribe(
			(response) => {
				if (response == false) {
					this.FinishAdd();
				} else {
					this.processing = false;
					this.errorMessage = "Username already in use";
					return;
				}
			},
			(error) => {
				this.processing = false;
				this.errorMessage = "Error checking username";
				return;
			}
		);
	}

	FinishAdd() {
		//
		// Create Request
		//
		let parms: CreateSubRequest = {
			FirstName: this.FirstName,
			LastName: this.LastName,
			SchoolID: this.SchoolID,
			EmailAddress: this.DomainSelect == "Manual" ? this.Email : this.Email + "@" + this.EmailProvider.EmailProviderEmailInfo,
			Username: this.UserName,
			AdminDefinedBy: this.user.UserLevelID == 3 ? 3 : 4,
		};

		//
		// Call WS
		//

		var result = this.SubstituteMaintenanceService.CreateSubstituteUser(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response) == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addaccount",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"User was created successfully. They will receive an email with their login info. Make sure to assign them to sub for one or more teachers.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addaccount",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the user: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////
	onFirstNameChange(val) {
		this.FirstName = val;

		this.UpdateUserName();
	}

	onLastNameChange(val) {
		this.LastName = val;

		this.UpdateUserName();
	}

	onRadioChange(val) {
		this.DomainSelect = val;

		this.Email = "";
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////
	UpdateUserName() {
		this.UserName = this.FirstName + "." + this.LastName;
	}

	IsLoading() {
		return this.LoadingEmail == true || this.processing == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	///////////////////////////////////////
}
